import React, { useEffect, useRef, useState } from 'react';
import withRouter from '../../../CommonComponents/WithRouter';
import { useSelector, shallowEqual, useDispatch } from 'react-redux';
import { SHOW_DEMO_POST } from '../../../../actions/wallsAction';
import { toggleAddFeedsSection_D, toggleManageSection_D } from '../../../../actions/showDisplayModalAction';
import { useNavigate } from 'react-router';
import Error from '../Themes/Error';
import LoadingScreen from '../../../CommonComponents/LoadingScreen';
import { getWidgetWallData } from '../../../../actions/wallDataAction';
import { PREVIEW_URL } from '../../../../actions/api';

function Themes({ params, showDemoWall, errorCode, error }) {
    const refreshThemes = useSelector(state => state.firstRun.refreshThemes, shallowEqual);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { wallData } = useSelector(state => state.wallData, shallowEqual);
    const wallId = Object.keys(params).length > 0 ? params.wallID : localStorage.getItem('wallId');
    const themeId = wallData ? wallData.wall?.Personalization?.ThemeRule.themeId : 0;
    const [demoWall, setDemoWall] = useState(showDemoWall)
    const [loadingIframe, setLoadingIframe] = useState(true)
    const [iframeSrc, setIframeSrc] = useState(null)
    const reloadCount = useRef(0)
    const lastSrcRef = useRef(null)
    const onboardingPreview = window.location.pathname.includes('/onboarding')

    const onShowDemoPost = (status) => {
        SHOW_DEMO_POST(status, wallId, () => {
            setDemoWall(status)
            onLoad(true);
            if (status == 1 && !errorCode) dispatch(getWidgetWallData(localStorage.getItem('ownerId'), localStorage.getItem('wallId')))
        })
    }

    window.onShowDemoPost_D = onShowDemoPost
    window.onShowDemoPost = onShowDemoPost

    const onLoad = (forceReload = false) => {
        window.editor = true;
        const newSrc = `${PREVIEW_URL}${localStorage.getItem('wallId')}${themeId > 61 || onboardingPreview ? `&editor=1&socialwalls=1` : `?studio=1`}`;
        if (!forceReload && newSrc === lastSrcRef.current) return;
        lastSrcRef.current = newSrc;
        setLoadingIframe(true)
        if (forceReload) reloadCount.current += 1;
        setIframeSrc(newSrc);
    }
    useEffect(() => {
        if (themeId || onboardingPreview) onLoad();
        if (!wallData?.wall?.Personalization) dispatch(getWidgetWallData(localStorage.getItem('ownerId'), localStorage.getItem('wallId')))
    }, [refreshThemes, themeId, params.wallID, errorCode])

    useEffect(() => {
        setDemoWall(showDemoWall)
    }, [showDemoWall])

    useEffect(() => {
        const handleMessage = (event) => {
            if (event?.origin.includes("socialwalls.com")) {
                if (event.data === 'ShowDemoWall') { onShowDemoPost(1) }
                else if (event.data === 'HideDemoWall') { onShowDemoPost(0) }
                else if (event.data === "AddFeed") { dispatch(toggleAddFeedsSection_D(true)); navigate(`/wall/index/${localStorage.getItem('wallId')}`) }
                else if (event.data === "ManageFeed") { dispatch(toggleManageSection_D(true)); navigate(`/wall/index/${localStorage.getItem('wallId')}`) }
                else if (event.data === "ChangeDateRange") { navigate(`/wall/personalize/${localStorage.getItem('wallId')}?tab=changeDateRange`) }
                else if (event.data === "Moderation") { navigate(`/moderation/index/${localStorage.getItem('wallId')}`) }
                else if (event.data === "ChangeTheme") { navigate(`/wall/personalize/${localStorage.getItem('wallId')}`) }
            }
        }
        window.addEventListener('message', handleMessage);
        return () => {
            window.removeEventListener('message', handleMessage);
        };
    }, []);


    return <> <div id="wallRender">
        {iframeSrc ? <iframe key={reloadCount.current} title="wall-preview" src={iframeSrc} width="100%" height="100%" onLoad={() => setLoadingIframe(false)}></iframe> : null}
        <div className="wall-preview-loader" style={{ display: loadingIframe ? 'flex' : 'none' }}><LoadingScreen /></div>
        {demoWall == 1 && errorCode ? <Error errorData={error} onShowDemoPost={onShowDemoPost} /> : <></>}
    </div>
    </>
}

export default withRouter(React.memo(Themes))